import { styled, theme } from '@clickcease/cc-client-components-lib'

export const DomainManagementRowStyled = styled('tr', {
  display: 'table-row',
  position: 'relative',
  alignItems: 'center',
  height: theme.space['32'].value,
  maxWidth: '0',
  ['&:hover']: {
    background: '$tableHovered',
  },
})

const ContentSection = styled('td')

export const Domain = styled(ContentSection, {
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$m',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: '35%',
  maxWidth: '0',

  '@laptop': {
    width: '30%',
  },
})

export const PaidMarketingPart = styled(ContentSection)

export const BotMitigationPart = styled(ContentSection)

export const TagManagementPart = styled(ContentSection, {
  maxWidth: '0', // Takeing the width from the column title
})

export const ClickceaseDomainMigrationPart = styled(ContentSection, {
  // Not allowed to turn off the switch
  button: {
    '&[data-state = checked]': {
      cursor: 'not-allowed',
    },
  },
})

export const SwitchWrapper = styled('span', {})

export const MultipleElementsWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
})

export const ClickceaseDomainMigrationWrapper = styled(MultipleElementsWrapper)

export const Connected = styled('div', {
  background: '$lightGreen',
  borderRadius: '$2',
  width: '93px',
  height: '24px',
  fontWeight: '$r',
  fontSize: '$sm',
  color: '$green',
  textAlign: 'center',
  lineHeight: '24px',
})

export const SetupButton = styled('button', {
  background: '#FFFFFF',
  border: '1px solid $primaryColor',
  width: '91px',
  height: '31px',
  color: '$primaryColor',
  textAlign: 'center',
  fontWeight: '$sb',
  lineHeight: '27px',
  cursor: 'pointer',
  fontSize: '$md',
  borderRadius: '$normal',
  display: 'flex',
  justifyContent: 'center',
  variants: {
    disabled: {
      true: {
        background: '$lightDisabled',
        border: '1px solid $lightDisabled',
        color: '$disabled',
        cursor: 'not-allowed',
      },
    },
  },
})
export const MonitoringWrapper = styled('div', {
  display: 'flex',
  marginLeft: '$12',
})

export const DisabledProduct = styled('div', {
  textAlign: 'center',
  lineHeight: '24px',
  backgroundColor: '$veryLightNeutral',
  color: '$neutral',
  width: '100px',
  height: '24px',
  fontSize: '$sm',
  fontWeight: '$r',
})

export const TableText = styled('div', {
  fontWeight: '$l',
  fontSize: '$m',
  marginLeft: '$4',
  color: '$mainTextColor',
  lineHeight: '15px',
})
